import React from "react"

function VideoReviews() {
  return (
    <section id="video-reviews">
      <div className="max-w-6xl mx-auto px-4 sm:px-6">
        <div className="py-12 md:py-20 border-t border-gray-800">
          {/* Section header */}
          <div className="max-w-3xl mx-auto text-center pb-8 md:pb-12">
            <h2 className="h2 mb-4" data-aos="fade-up">
              Video reviews
            </h2>
            <p
              className="text-xl text-gray-400"
              data-aos="fade-up"
              data-aos-delay="200"
            >
              Check out video reviews from our clients.
            </p>
          </div>
          {/* Items */}
          <div
            className="grid gap-2 grid-cols-2 md:grid-cols-2 shadow-2xl shadow-indigo-500/30"
            data-aos-id-video-reviews
          >
            {/* Item */}
            <div
              className="flex items-center justify-center h-72"
              data-aos="fade-up"
              data-aos-anchor="[data-aos-id-video-reviews]"
              data-aos-delay="200"
            >
              <iframe
                width="100%"
                height="100%"
                src="https://www.youtube.com/embed/tUi19MUK8wo"
                frameBorder="0"
                allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
                allowFullScreen
              ></iframe>
            </div>

            <div
              className="flex items-center justify-center h-72"
              data-aos="fade-up"
              data-aos-anchor="[data-aos-id-video-reviews]"
              data-aos-delay="200"
            >
              <iframe
                width="100%"
                height="100%"
                src="https://www.youtube.com/embed/LJvENJs5_Dc"
                frameBorder="0"
                allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
                allowFullScreen
              ></iframe>
            </div>

            <div
              className="flex items-center justify-center h-72"
              data-aos="fade-up"
              data-aos-anchor="[data-aos-id-video-reviews]"
              data-aos-delay="200"
            >
              <iframe
                width="100%"
                height="100%"
                src="https://www.youtube.com/embed/FebhELI4eqs"
                frameBorder="0"
                allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
                allowFullScreen
              ></iframe>
            </div>

            <div
              className="flex items-center justify-center h-72"
              data-aos="fade-up"
              data-aos-anchor="[data-aos-id-video-reviews]"
              data-aos-delay="400"
            >
              <iframe
                width="100%"
                height="100%"
                src="https://www.youtube.com/embed/G_k8XpLvh10"
                frameBorder="0"
                allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
                allowFullScreen
              ></iframe>
            </div>
          </div>
        </div>
      </div>
    </section>
  )
}

export default VideoReviews
